// extracted by mini-css-extract-plugin
export default {"form1":"LoginDetails_form1__WqIBD","formstyle":"LoginDetails_formstyle__NGLUN"};